import React, { useState, useEffect, useRef, useMemo, useCallback, } from "react";
import { Outlet, Routes, Route, useLocation, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import NavInner from '@/components/NavInner'
import { Breadcrumb, Button, Drawer, Layout, Menu, MenuProps, Modal, Tooltip, theme, message, Flex } from 'antd';
import UFooter from '@/components/Footer/index';
import MenuItem from "antd/es/menu/MenuItem";
// import NavInnerFooter from "@/components/NavInnerFooter";
import { useTranslation } from 'react-i18next';
import { toggleSide } from "@/stores/actions";
import { AppstoreOutlined, BookOutlined, BulbOutlined, LineChartOutlined, DeploymentUnitOutlined, DollarOutlined, EuroOutlined, FileAddOutlined, FileTextOutlined, FireOutlined, HomeFilled, HomeOutlined, LockOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MinusSquareOutlined, PlusCircleOutlined, PlusSquareOutlined, RobotOutlined, SwapOutlined, ToolOutlined, WalletOutlined, CloudOutlined, CloudUploadOutlined } from "@ant-design/icons";
import PriorityFeeButton from "@/components/NavInner/PriorityFeeButton";
import PhishingWarning from "@/components/PhishingWarning";
import MyIcon from "@/router/Icon";
import { useNewRouteModule } from '@/hooks/useNewRouteModule';
import { replaceLangPath } from '@/utils/methods';
import { getChainsResource } from "@/utils/methods";
import "./MainLayout.less"
import { cdnUrl } from "@/utils/cdn";
import BatchSwap from "@/pages/BatchSwap";
const { Header, Content, Footer, Sider } = Layout;
// import BottomMenu from "../components/BottomMenu";
type MenuItem = Required<MenuProps>['items'][number];

// const specifiedDate = Date.parse('2024-04-16 00:00:00')
// function checkAndUpdateCache(expirationTime: any) {
//   let storedTime: any = localStorage.getItem('menuCacheTime')
//   let storedTimeTmp: any = new Date(storedTime)

//   if (!storedTime || expirationTime > Date.parse(storedTimeTmp)) {
//     localStorage.removeItem('noMenuNew');
//     localStorage.setItem('menuCacheTime', new Date().toISOString());
//     console.log('Menu cache cleared and updated.');
//   } else {
//     console.log('Menu cache is still valid.');
//   }
// }
const { urlSuffix, imgPathPrefix, webTittle }: any = getChainsResource();
console.log("urlSuffix", urlSuffix)
let timer: any = null;
let noticeItemHeight = 46;
const MainLayout: React.FC = (): JSX.Element => {
  const { noNewMenu, updateNoMenuNew, getIsMenuNew } = useNewRouteModule();
  // console.log('MainLayout noNewMenu',noNewMenu)
  // const locMenuData: any = localStorage.getItem('noMenuNew') || "[]"
  const dispatch = useDispatch()
  const location = useLocation();
  const contentRef = useRef<any>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const {
    isM, is1920, is1440, is1200, is750
  } = useSelector((state: any) => {
    return state.device
  })

  const { show } = useSelector((state: any) => {
    return state.side
  })
  const { t, i18n } = useTranslation()
  // console.log(i18n.language, 'i18n.language')
  const [collapsed, setCollapsed] = useState(false);
  const [openQQ, setOpenQQ] = useState(false);
  const [openWX, setOpenWX] = useState(false);
  const [openSubs, setOpenSubs] = useState<any>([]);
  // const [noNewMenu, setNoNewMenu] = useState<any>(JSON.parse(locMenuData));
  const { lang } = useParams<{ lang: string }>();
  const noticeList = useMemo(() => {
    return [
      {
        text: t('notice.tip-1'),
        link: `/${i18n.language}/liquidity-create-and-buy-token/solana`
      },
      {
        text: t('notice.tip-2'),
        link: `/${i18n.language}/token-vanity-creator/solana`
      },
      {
        text: t('notice.tip-3'),
        link: `/${i18n.language}/multi-swap/solana`
      }
    ]
  }, [i18n.language]);


  const [scrollHeight, setScrollHeight] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    let switchUl: any = document.getElementsByClassName('notice-list')[0];
    if (switchUl && noticeList.length > 1) {
      // 滚动话术区域的定时器
      timer = setInterval(() => {
        // 这里的noticeItemHeight是每一条li的高度                    
        if (scrollHeight <= 0 - noticeItemHeight * noticeList.length) {
          switchUl.style.transition = 'none'; // 为了是轮播图呈现出循环效果，之前的轮播在运行到最后一个的时候会有所有项都滚动下来
          setScrollHeight(0);
        } else {
          if (scrollHeight === 0) {
            switchUl.style.transition = 'all .5s linear'; // 因为上一步将动画效果置为了none，所以在轮播图为第一个的时候再加上这个动画效果
          }
          setScrollHeight(scrollHeight - noticeItemHeight);
        }
      }, 5000);
    }
    return () => {
      clearInterval(timer);
    };

  }, [noticeList, scrollHeight]);


  function getWidth() {
    if (is1920) {
      return 280
    }

    if (is1440) {
      return 280
    }

    return 280
  }

  function getPl() {
    if (is1920) {
      return 34
    }

    if (i18n.language === 'en-us') {
      return 10
    } else {
      return 24
    }


  }

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    disabled?: boolean,
    children?: MenuItem[],
    type?: 'group'
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled
    } as MenuItem;
  }
  const handleScroll = () => {
    setScrollPosition(contentRef.current.scrollTop)
    // const position = window.pageYOffset || document.documentElement.scrollTop;
    // setScrollPosition(position);
  };

  useEffect(() => {
    const element: any = contentRef.current;
    element && element.addEventListener('scroll', handleScroll);
    return () => element?.removeEventListener('scroll', handleScroll);
  }, []);


  function onClickMenu(el: any) {
    // const accessibleList = [
    //   getLangUrl('/multi-sender/' + urlSuffix),
    //   getLangUrl('/token-batch-collection/' + urlSuffix),
    //   getLangUrl('/token-creator/' + urlSuffix),
    //   getLangUrl('/wallet-creator/' + urlSuffix)
    // ]
    // if (!accessibleList.includes(el.key)) {
    //   messageApi.warning({
    //     content: "Coming soon!",
    //   });
    //   el.domEvent.preventDefault();
    // }
    updateNoMenuNew(el.key);
    // localStorage.setItem('noMenuNew', JSON.stringify(updatedMenu));
  }

  function onOpenChange(el: any[]) {
    // console.log(el,openSubs, 'onOpenChange');
    updateNoMenuNew(el);
    setOpenSubs([...new Set([...el])])
    // const updatedMenu = [...new Set([...noNewMenu, ...el])];
    // setNoNewMenu(updatedMenu);
    // localStorage.setItem('noMenuNew', JSON.stringify(updatedMenu));
    // updateNoMenuNew(el.key);
  }


  const renderNew = useCallback((url: any = '') => {
    // if (noNewMenu.includes(url)) {
    //   return <></>
    // }

    return getIsMenuNew(url) && <img src={cdnUrl("/img/slerf/new.svg")} alt="" /> || null
  }, [noNewMenu])

  function ToolTipMenu({ children }: any) {
    return (<Tooltip placement="topLeft" title={t('tips.comingSoon')} arrow={true} classNames={{ root: 'tooltip-menu' }}>
      {
        children
      }
    </Tooltip>)
  }

  function getLangUrl(url: string = '') {
    return `${lang ? `/${lang}` : ``}${url}`
  }
  const items: any = [
    // 首页
    getItem(<Link to={getLangUrl('/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.home')}</span></Link>, getLangUrl('/' + urlSuffix), <MyIcon type="icon-biaozhundaibi" style={{ color: "white" }}></MyIcon>),
    getItem(<Link to={getLangUrl('/token-creator/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.standardToken')}</span></Link>, getLangUrl('/token-creator/' + urlSuffix), <MyIcon type="icon-biaozhundaibi" style={{ color: "white" }}></MyIcon>),
    getItem(<Link to={getLangUrl('/token-management/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.token')}</span></Link>, getLangUrl('/token-management/' + urlSuffix), <MyIcon type="icon-a-daibiguanli1" style={{ color: "white" }}></MyIcon>),
    getItem(<Link to={getLangUrl('/batch-wallet-generate/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.BatchWalletGeneration')}</span></Link>, getLangUrl('/batch-wallet-generate/' + urlSuffix), <MyIcon type="icon-a-MnemonicPhrase" style={{ color: "white" }}></MyIcon>),

    // getItem(<Link to={getLangUrl('/burn-token/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.BatchWalletGeneration')}</span></Link>, getLangUrl('/burn-token/' + urlSuffix), <MyIcon type="icon-a-daibiguanli1"></MyIcon>),
    // getItem(<Link to={getLangUrl(`/bsc`)}>{t('nav.home')}</Link>, getLangUrl('/bsc'), <img src={cdnUrl(`/img/menu/home.svg`)} alt="" />),
    // getItem(<div className="img-title"><span>{t('nav.creatingToken')}</span></div>, 'tokenManage', <img src={cdnUrl(`/img/menu/token.svg`)} alt="" />, false, [  
    //   // 标准代币
    //   getItem(<Link to={getLangUrl('/token-creator/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.standardToken')}</span></Link>, getLangUrl('/token-creator/' + urlSuffix), <i className="iconfont">&#xe67c;</i>),
    //   // 靓号代币
    //   getItem(<Link to={getLangUrl('/token-vanity-creator/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.vanityToken')}</span></Link>, getLangUrl('/token-vanity-creator/' + urlSuffix), <i className="iconfont">&#xe6ad;</i>),
    //   // 税收代币
    //   getItem(<Link to={getLangUrl('/create-tax-token/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.taxTokens')}</span></Link>, getLangUrl('/create-tax-token/' + urlSuffix), <i className="iconfont">&#xe696;</i>),
    //   // 分红代币
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.dividendTokens')}</span></span></ToolTipMenu>, getLangUrl('/fenhong' + urlSuffix), <i className="iconfont">&#xe69e;</i>, true),
    //   // 回流代币
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.returnTokens')}</span></span></ToolTipMenu>, getLangUrl('/huiliu' + urlSuffix), <i className="iconfont">&#xe685;</i>, true),
    //   // 314协议
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.314Protocol')}</span></span></ToolTipMenu>, getLangUrl('/314' + urlSuffix), <i className="iconfont">&#xe67e;</i>, true),
    //   // 代币管理
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.tokenManagement')}</span></span></ToolTipMenu>, getLangUrl('/token' + urlSuffix), <i className="iconfont">&#xe67d;</i>, true),
    // ]),
    // getItem(<div className="img-title"><span>{t('nav.walletManagement')}</span></div>, 'walletManage', <img src={cdnUrl(`/img/menu/wallet.svg`)} alt="" />, false, [
    //   // 批量生成钱包
    //   getItem(<Link to={getLangUrl('/wallet-creator/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.BatchWalletGeneration')}</span></Link>, getLangUrl('/wallet-creator/' + urlSuffix), <i className="iconfont">&#xe69c;</i>),
    //   // 批量查询余额
    //   getItem(<Link to={getLangUrl('/batch-query-balance/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.batchQueryBalance')}</span></Link>, getLangUrl('/batch-query-balance/' + urlSuffix), <i className="iconfont">&#xe684;</i>),
    //   // 生成靓号钱包
    //   getItem(<Link to={getLangUrl('/vanity-wallet-generator/' + urlSuffix)} target="_blank" className="img-title"><span className="img-title"><span>{t('nav.generateAWalletWithAGoodNumber')}</span></span></Link>, getLangUrl('/vanity-wallet-generator/' + urlSuffix), <i className="iconfont">&#xe695;</i>),
    //   //助记词生成钱包
    //   getItem(<Link to={getLangUrl('/mnemonic-wallet-generator/' + urlSuffix)} target="_blank" className="img-title"><span className="img-title"><span>{t('generateFromMnemonic.generateMnemonicWallet')}</span></span></Link>, getLangUrl('/mnemonic-wallet-generator/' + urlSuffix), <img src={cdnUrl(`/img/bsc/Mnemonic.svg`)} />),
    //   // 钱包资产迁移
    //   getItem(<Link to={getLangUrl('/wallet-asset-migrator/' + urlSuffix)} target="_blank" className="img-title"><span className="img-title"><span>{t('nav.walletAssetMigration')}</span></span></Link>, getLangUrl('/wallet-asset-migrator/' + urlSuffix), <i className="iconfont">&#xe695;</i>),
    //   // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.walletAssetMigration')}</span></span></ToolTipMenu>, getLangUrl('/walletAssetRemove' + urlSuffix),  <i className="iconfont">&#xe697;</i>, true), 
    //   // 钱包清仓
    //   getItem(<Link to={getLangUrl('/full-token-sell/' + urlSuffix)} target="_blank" className="img-title"><span className="img-title"><span>{t('nav.walletClearance')}</span></span></Link>, getLangUrl('/full-token-sell/' + urlSuffix), <i className="iconfont">&#xe6c1;</i>),
    // ]),
    getItem(<div className="img-title"><span>{t('nav.batchTransfer')}</span></div>, 'batchTransfer', <MyIcon type="icon-piliangzhuanzhang" style={{ color: "white" }}></MyIcon>, false, [
      //   // 一转多
      getItem(<Link to={getLangUrl('/multi-sender/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.oneTurnMore')}</span></Link>, getLangUrl('/multi-sender/' + urlSuffix), <MyIcon type="icon-yizhuanduo" style={{ color: "white" }}></MyIcon>),
      // 多转一
      getItem(<Link to={getLangUrl('/token-batch-collection/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.oneMoreTurn')}</span></Link>, getLangUrl('/token-batch-collection/' + urlSuffix), <MyIcon type="icon-duozhuanyi" style={{ color: "white" }}></MyIcon>),
      //   // 多对多转账
      getItem(<Link to={getLangUrl('/multisender-many-to-many/' + urlSuffix)} target="_blank" className="img-title"><span>{t("manyToMany.nav")}</span>{renderNew(getLangUrl('/multisender-many-to-many/' + urlSuffix))}</Link>, getLangUrl('/multisender-many-to-many/' + urlSuffix), <MyIcon type="icon-duozhuanduo" style={{ color: "white" }}></MyIcon>),
      //   // 中转转账
      getItem(<Link to={getLangUrl('/relay-transfer/' + urlSuffix)} target="_blank" className="img-title"><span>{t("IntermediaryTransfer.title")}</span>{renderNew(getLangUrl('/relay-transfer/' + urlSuffix))}</Link>, getLangUrl('/relay-transfer/' + urlSuffix), <MyIcon type="icon-zhongzhuan" style={{ color: "white" }}></MyIcon>),
      //   // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.transfer')}</span></span></ToolTipMenu>, getLangUrl('/transfer' + urlSuffix),  <i className="iconfont">&#xe69b;</i>, true),
    ]),
    getItem(<div className="img-title"><span>{t('nav.liquidityManagement')}</span></div>, 'liquidityManagement', <MyIcon type="icon-liudongxingguanli" style={{ color: "white" }}></MyIcon>, false, [
      getItem(<Link to={getLangUrl('/create-liquidity-pool/' + urlSuffix)} target="_blank" className="img-title"><span>{t("nav.createLiquidity")}</span>{renderNew(getLangUrl('/create-liquidity-pool/' + urlSuffix))}</Link>, getLangUrl('/create-liquidity-pool/' + urlSuffix), <MyIcon type="icon-chuangjianliudongxing" style={{ color: "white" }}></MyIcon>),
      //  添加流动性
      getItem(<Link to={getLangUrl('/add-liquidity-pool/' + urlSuffix)} target="_blank" className="img-title"><span>{t("nav.addingLiquidity")}</span>{renderNew(getLangUrl('/add-liquidity-pool/' + urlSuffix))}</Link>, getLangUrl('/add-liquidity-pool/' + urlSuffix), <MyIcon type="icon-tianjialiudongxing" style={{ color: "white" }}></MyIcon>),
    ]),
    getItem(<Link to={getLangUrl('/batch-swap/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.batchSwap')} </span></Flex></Link>, getLangUrl('/batch-swap/' + urlSuffix), <MyIcon type="icon-piliangjiaoyi" style={{ color: "white" }}></MyIcon>),
    // getItem(<div className="img-title"><span>{t('nav.liquidityManagement')}</span></div>, 'liquidityManagement', <img src={cdnUrl(`/img/menu/liquidity.svg`)} alt="" />, false, [
    //   // 创建流动性

    //   // 创建流动性并买入
    //   getItem(<Link to={getLangUrl('/liquidity-create-and-buy-token/' + urlSuffix)} target="_blank" className="img-title"><span>{t("nav.CreateLiquidityBuy")}</span>{renderNew(getLangUrl('/liquidity-create-and-buy-token/' + urlSuffix))}</Link>, getLangUrl('/liquidity-create-and-buy-token/' + urlSuffix), <i className="iconfont">&#xe6b6;</i>),
    //   // 领取流动性收益
    //   getItem(<Link to={getLangUrl('/claim-liquidity-rewards/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.receiveLiquidityIncome')}</span>{renderNew(getLangUrl('/claim-liquidity-rewards/' + urlSuffix))}</Link>, getLangUrl('/claim-liquidity-rewards/' + urlSuffix), <i className="iconfont">&#xe690;</i>),
    //   // 移除流动性池
    //   getItem(<Link to={getLangUrl('/remove-liquidity-pool/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.removeLiquidityPool')}</span>{renderNew(getLangUrl('/remove-liquidity-pool/' + urlSuffix))}</Link>, getLangUrl('/remove-liquidity-pool/' + urlSuffix), <i className="iconfont">&#xe68f;</i>),
    //   // 燃烧流动性池
    //   getItem(<Link to={getLangUrl('/burn-liquidity-pool/' + urlSuffix)} target="_blank" className="img-title"><span>{t('nav.burnLiquidityPool')}</span>{renderNew(getLangUrl('/burn-liquidity-pool/' + urlSuffix))}</Link>, getLangUrl('/burn-liquidity-pool/' + urlSuffix), <i className="iconfont">&#xe689;</i>),
    //   // 添加流动性
    // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.addingLiquidity')}</span></span></ToolTipMenu>, getLangUrl('/addLiquidity' + urlSuffix), <i className="iconfont">&#xe68c;</i>, true),
    //   // 锁仓流动性
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.lockLiquidity')}</span></span></ToolTipMenu>, getLangUrl('/lockLiquidity' + urlSuffix), <i className="iconfont">&#xe694;</i>, true),
    //   // 解锁流动性
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.unlockLiquidity')}</span></span></ToolTipMenu>, getLangUrl('/unlockLiquidity' + urlSuffix), <i className="iconfont">&#xe681;</i>, true),
    //   // 我的流动性
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.myLiquidity')}</span></span></ToolTipMenu>, getLangUrl('/myLiquidity' + urlSuffix), <i className="iconfont">&#xe699;</i>, true),
    // ]),
    // //pancakeswap专区
    // getItem(<div className="img-title"><span>{t('nav.tradingTools')}</span></div>, 'tradeTool', <img src={cdnUrl(`${imgPathPrefix}pancake.svg`)} alt="" />, false, [
    //   // 批量交易
    //   getItem(<Link to={getLangUrl('/batch-swap/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.batchSwap')} </span></Flex></Link>, getLangUrl('/batch-swap/' + urlSuffix), <i className="iconfont">&#xe68e;</i>),
    //   // 防夹刷量
    //   getItem(<Link to={getLangUrl('/pancakeswap-anti-mev-bot/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.antiSandwichTrades')} </span></Flex></Link>, getLangUrl('/pancakeswap-anti-mev-bot/' + urlSuffix), <i className="iconfont">&#xe688;</i>),
    //   // 多地址捆绑买入
    //   getItem(<Link to={getLangUrl('/pancakeswap-bundled-buy/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.bundledBuy')} </span></Flex></Link>, getLangUrl('/pancakeswap-bundled-buy/' + urlSuffix), <i className="iconfont">&#xe692;</i>),
    //   // 多地址捆绑卖出
    //   getItem(<Link to={getLangUrl('/pancakeswap-bundled-sell/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.bundledSell')} </span></Flex></Link>, getLangUrl('/pancakeswap-bundled-sell/' + urlSuffix), <i className="iconfont">&#xe686;</i>),
    //   // 新地址买入（↑Holders）
    //   getItem(<Link to={getLangUrl('/pancakeswap-new-buy/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.newAddressBuyHolders')} </span></Flex></Link>, getLangUrl('/pancakeswap-new-buy/' + urlSuffix), <i className="iconfont">&#xe691;</i>),
    //   //交易加速/取消
    //   getItem(<Link to={getLangUrl('/transaction-speedup-cancel/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.transactionAccelerationCancellation')} </span></Flex></Link>, getLangUrl('/transaction-speedup-cancel/' + urlSuffix), <i className="iconfont">&#xe67f;</i>),
    //   // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.transactionAccelerationCancellation')}</span></span></ToolTipMenu>, getLangUrl('/transactionAccelerationCancellation' + urlSuffix),  <i className="iconfont">&#xe67f;</i>, true),
    //   //活跃刷单
    //   getItem(<Link to={getLangUrl('/pancakeswap-auto-trade-booster/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('activeTrade.dexActiveTrade', { dex: '' })} </span></Flex></Link>, getLangUrl('/pancakeswap-auto-trade-booster/' + urlSuffix), <img src={cdnUrl(`/img/menu/huoyueshuadan.svg`)} />),
    //   // BSC Swap
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.BSCSwap')}</span></span></ToolTipMenu>, getLangUrl('/bscSwap' + urlSuffix), <i className="iconfont">&#xe67b;</i>, true),
    //   // 科学家抢币
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.scientistsGrabCoins')}</span></span></ToolTipMenu>, getLangUrl('/scientistsGrabCoins' + urlSuffix), <i className="iconfont">&#xe68a;</i>, true),
    // ]),
    // getItem(<div className="img-title"><span>{t('nav.fourMemeZone')}</span></div>, 'fourMeme', <img src={cdnUrl(`/img/menu/four.svg`)} alt="" />, false, [
    //   //创建代币并捆绑买入
    //   getItem(<Link to={getLangUrl('/fourmeme-create-token-and-buy/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center" gap={8}><span>{t('nav.memeLaunchAndBuyToken')} </span><img src={cdnUrl(`/img/bsc/four-usd1.svg`)} alt="" /></Flex></Link>, getLangUrl('/fourmeme-create-token-and-buy/' + urlSuffix), <img src={cdnUrl(`${imgPathPrefix}menu/four-chuangjianbingkunbangmairu.svg`)} />),
    //   // 批量交易
    //   getItem(<Link to={getLangUrl('/fourmeme-batch-swap/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.batchSwap')} </span></Flex></Link>, getLangUrl('/fourmeme-batch-swap/' + urlSuffix), <img src={cdnUrl(`${imgPathPrefix}menu/four-piliangjiaoyi.svg`)} />),
    //   // 防夹刷量
    //   getItem(<Link to={getLangUrl('/fourmeme-anti-mev-bot/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.antiSandwichTrades')} </span></Flex></Link>, getLangUrl('/fourmeme-anti-mev-bot/' + urlSuffix), <img src={cdnUrl(`${imgPathPrefix}menu/four-fangjiashualiang.svg`)} />),
    //   // 多地址捆绑买入
    //   getItem(<Link to={getLangUrl('/fourmeme-bundled-buy/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.bundledBuy')} </span></Flex></Link>, getLangUrl('/fourmeme-bundled-buy/' + urlSuffix), <img src={cdnUrl(`${imgPathPrefix}menu/four-kunbangmairu.svg`)} />),
    //   // 多地址捆绑卖出
    //   getItem(<Link to={getLangUrl('/fourmeme-bundled-sell/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.bundledSell')} </span></Flex></Link>, getLangUrl('/fourmeme-bundled-sell/' + urlSuffix), <img src={cdnUrl(`${imgPathPrefix}menu/four-kunbangmaichu.svg`)} />),
    //   // 新地址买入（↑Holders）
    //   getItem(<Link to={getLangUrl('/fourmeme-new-buy/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.newAddressBuyHolders')} </span></Flex></Link>, getLangUrl('/fourmeme-new-buy/' + urlSuffix), <i className="iconfont">&#xe691;</i>),
    //   // 活跃刷单
    //   getItem(<Link to={getLangUrl('/fourmeme-auto-trade-booster/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('activeTrade.dexActiveTrade', { dex: '' })}</span></Flex></Link>, getLangUrl('/fourmeme-auto-trade-booster/' + urlSuffix), <img src={cdnUrl(`/img/menu/activeTradeFourMeme.svg`)} />),
    // ]),
    // getItem(<div className="img-title"><span>{t('nav.convenientTools')}</span></div>, 'convenientTools', <img src={cdnUrl(`/img/menu/convenientTools.svg`)} alt="" />, false, [
    //   //授权查询
    //   getItem(<Link to={getLangUrl('/approval-checker/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.authorizationQuery')} </span></Flex></Link>, getLangUrl('/approval-checker' + urlSuffix), <i className="iconfont">&#xe693;</i>),
    //   //自定义授权
    //   // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.customAuthorization')}</span></span></ToolTipMenu>, getLangUrl('/customizedAuthorization' + urlSuffix),  <i className="iconfont">&#xe69a;</i>, true),
    //   getItem(<Link to={getLangUrl('/pre-approval/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.customAuthorization')} </span></Flex></Link>, getLangUrl('/pre-approval/' + urlSuffix), <img src={cdnUrl(`/img/menu/cauthorization.svg`)} />),
    //   //批量授权
    //   getItem(<Link to={getLangUrl('/batch-pre-approval/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.batchAuthorization')} </span></Flex></Link>, getLangUrl('/batch-pre-approval/' + urlSuffix), <i className="iconfont">&#xe69d;</i>),
    //   //节点测速
    //   getItem(<Link to={getLangUrl('/rpc-serve/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.nodeSpeedTest')} </span></Flex></Link>, getLangUrl('/rpc-serve/' + urlSuffix), <i className="iconfont">&#xe683;</i>),
    //   // getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.nodeSpeedTest')}</span></span></ToolTipMenu>, getLangUrl('/nodeSpeedTest' + urlSuffix), <i className="iconfont">&#xe683;</i>, true),
    //   //合约检查
    //   getItem(<Link to={getLangUrl('/contract-check/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('contractCheck.seo.navbar')}</span></Flex></Link>, getLangUrl('/contract-check/' + urlSuffix), <i className="iconfont">&#xe707;</i>),
    //   //代币快照
    //   //  getItem(<Link to={getLangUrl('/token-snapshot/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.tokenSnapshot')} </span></Flex></Link>, getLangUrl('/token-snapshot' + urlSuffix),  <i className="iconfont">&#xe6b4;</i>),
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.tokenSnapshot')}</span></span></ToolTipMenu>, getLangUrl('/token-snapshot' + urlSuffix), <i className="iconfont">&#xe6b4;</i>, true),

    //   //GAS花费统计
    //   getItem(<ToolTipMenu><span className="img-title comming"><span>{t('nav.gasCostStatistics')}</span></span></ToolTipMenu>, getLangUrl('/gasCostStatistics' + urlSuffix), <i className="iconfont">&#xe680;</i>, true),
    // ]),
    // getItem(<div className="img-title"><span>{t('nav.slerfToolsLock')}</span></div>, 'slerfToolsLock', <i className="iconfont">&#xe70a;</i>, false, [
    //   getItem(<Link to={getLangUrl('/coin-lock/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.createLock')}</span></Flex></Link>, getLangUrl('/coin-lock/' + urlSuffix), <i className="iconfont">&#xe709;</i>),
    //   getItem(<Link to={getLangUrl('/coin-lock-list/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.lockToken')}</span></Flex></Link>, getLangUrl('/coin-lock-list/' + urlSuffix), <i className="iconfont">&#xe70b;</i>),
    //   getItem(<Link to={getLangUrl('/coin-lock-lp/' + urlSuffix)} target="_blank" className="img-title"><Flex align="center"><span>{t('nav.lockLiquidity1')}</span></Flex></Link>, getLangUrl('/coin-lock-lp/' + urlSuffix), <i className="iconfont">&#xe708;</i>),
    // ]),

  ];
  // const bounceTransition = {
  //   duration: 0.4,
  //   yoyo: Infinity,
  //   ease: "easeOut"
  // };

  // useEffect(() => {
  //   checkAndUpdateCache(specifiedDate)
  // }, [])
  // console.log("urlSuffix", urlSuffix)
  function renderSider() {
    return (
      <Sider
        trigger={null}
        width={getWidth()}
        collapsible
        collapsed={collapsed}
        className="layout-sider">
        <div>
          <div className={
            collapsed ? "logo-mini" : "logo"
          }>
            <Button
              type="text"
              className="coll-btn"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                color: '#FFFFFF',
                fontSize: '16px',
                display: (isM || is750) ? 'none' : 'inline'
                // width: 64,
                // height: 64,
              }}
            />
            <a>
              {
                collapsed ? <MyIcon type="icon-a-sui1" style={{ fontSize: 32 }} ></MyIcon> : <div className="logo-main"><MyIcon type="icon-a-sui1" style={{ fontSize: 32 }} ></MyIcon><span>Slerf Tools</span></div>
              }
            </a>
          </div>
          {/* {
            (isM || is750) && <PriorityFeeButton />
          } */}
          <Menu
            className="layout-menu"
            mode="inline"
            defaultSelectedKeys={['home']}
            selectedKeys={[location.pathname]}
            // defaultOpenKeys={routeOpenSubs}
            openKeys={[...new Set([...openSubs])]}
            items={items}
            inlineIndent={getPl()}
            onClick={onClickMenu}
            onOpenChange={onOpenChange}
          />
        </div>
        <div className={collapsed ? "contact-ways close" : "contact-ways open"}>
          <div className="line-top"></div>
          {/* <div className="help-box">
            <a className="help-content" href={(i18n.language === 'zh-cn' || i18n.language === 'zh-hk') ? 'https://docs.slerf.tools/bsc-zh' : 'https://docs.slerf.tools/bsc-en'} target="__blank">
              <img src={cdnUrl('/img/help-icon.svg')} className="icon" alt="" />
              <div className="contents">
                <h4>{t('sider.helpCenter')}</h4>
                <p>{t('sider.whitepaperAndTutorials')}</p>
              </div>
              <img src={cdnUrl('/img/help-go.png')} className="go-icon" alt="" />
            </a>
          </div> */}
          <h3>{t("nav.contactUs")}</h3>
          <div className="ways">
            <a href="https://twitter.com/SlerfTools" target="_blank" className="x">
            </a>
            <a href="https://t.me/SlerfTools" className="tel" target="_blank">

            </a>
            <a href="mailto:BD@slerf.tools" className="email" target="_blank">

            </a>
            <a href="https://github.com/slerfTools/slerfTools" target="_blank" className="git">
            </a>
            <a href="https://blog.slerf.tools" target="_blank" className="blog">
            </a>
          </div>
        </div>
      </Sider>
    )
  }

  useEffect(() => {
    let openSubs = findParentKeys(location.pathname);
    setOpenSubs((prev: any) => { return [...prev, ...openSubs] })
  }, [location.pathname])

  // / 根据选中项找到所有父级key
  const findParentKeys = (key: string) => {
    const result: string[] = [];
    function find(list: any, parentKey: string | null) {
      for (const item of list) {
        if (item.key === key && parentKey) {
          result.push(parentKey);
          return true;
        }
        if (item.children) {
          if (find(item.children, item.key)) {
            if (parentKey) {
              result.push(parentKey);
            }
            return true;
          }
        }
      }
      return false;
    }
    find(items, null);
    return result;
  };

  const onClose = () => {
    dispatch(toggleSide({
      show: false
    }))
  };
  const isIndexPage = () => {
    let path = replaceLangPath(location.pathname).replace(':lang', '');

    return path === '/' || path === ''
  }
  return (
    <>
      {/* <PhishingWarning/> */}
      {contextHolder}
      <Layout className={`layout ${collapsed ? 'layout-close' : ''} `} hasSider>
        {
          (!isM && !is750) && renderSider()
        }
        <Layout className={`layout-box ${isIndexPage() && scrollPosition == 0 ? 'index' : ''}`} ref={contentRef}
        >
          <Header
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              width: '100%'
            }}
            className="layout-head"
          >
            {/* <div className="notice-cotainer">
              <img src="/img/slerf/sound.png" alt="" />
              <div className="notice-body">
                <ul className="notice-list" style={{
                  ...{
                    transform: `translateY(${scrollHeight}px)`,
                  } as any
                }}>
                  {
                    noticeList.map((item: any, index: number) => {
                      return <li key={index}>
                        <a href={item.link} target="_blank" rel="noopener noreferrer" title={item.text}>{item.text}</a>
                      </li>
                    })
                  }
                  {
                    noticeList.length > 0 && (
                      <li >
                        <a href={noticeList[0].link} target="_blank" rel="noopener noreferrer">{noticeList[0].text}</a>
                      </li>
                    )
                  }
                </ul>
              </div>
            </div> */}
            {/* <img src={cdnUrl("/img/bsc/fourmeme-create-and-buy-usd1-btn.svg")} alt="" style={{ cursor: 'pointer' }} onClick={() => {
              window.open(`${getLangUrl('/fourmeme-create-token-and-buy/' + urlSuffix)}#USD1`, '_blank')
            }} /> */}
            <div></div>
            <NavInner />
          </Header>
          <Content className={`layout-content`} >
            {/* <TabsRouter routers={items} /> */}
            <div className="site-layout-content"><Outlet /></div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            <UFooter />
          </Footer>
        </Layout>
        <Modal
          title={t("home.qqQrCode")}
          centered
          footer={null}
          open={openQQ}
          onOk={() => setOpenQQ(false)}
          onCancel={() => setOpenQQ(false)}
          width={300}
        >
          <div className="qq-qrcode">
            <img src={cdnUrl("/img/slerf/qq-qrcode.png")} alt="" />
          </div>
        </Modal>
        <Modal
          title={t("home.wechatQrCode")}
          centered
          footer={null}
          open={openWX}
          onOk={() => setOpenWX(false)}
          onCancel={() => setOpenWX(false)}
          width={300}
        >
          <div className="wx-qrcode">
            <img src={cdnUrl("/img/slerf/wx-qrcode.png")} alt="" />
          </div>
        </Modal>
        <Drawer
          placement={'left'}
          closable={false}
          onClose={onClose}
          open={show}
          key={'left'}
          width={240}
          className={'cus-drawer'}
        >
          <Layout className="layout-drawer">
            {
              (isM || is750) && renderSider()
            }
          </Layout>
        </Drawer>
      </Layout>
    </>
  );
};

export default MainLayout;